export function uah(valueInCents) {
	return (valueInCents / 100).toLocaleString('uk-UA', {
		minimumFractionDigits: 2,
		maximumFractionDigits: 2
	})
}

export const fmt = (kopeks, locale = 'uk-UA') =>
	((Number(kopeks) || 0) / 100).toLocaleString(locale, {
		minimumFractionDigits: 2,
	})

export const getLineVat = (it) => {
	const taxes = it?.extras?.taxes || it?.taxes || []
	if (!Array.isArray(taxes) || !taxes.length) return 0

	const qty = Number(it?.quantity) || 0
	const price = Number(it?.price) || 0
	const gross = qty * price

	return taxes.reduce((sum, t) => {
		return sum + Math.round(gross * (Number(t?.rate) || 0) / 100)
	}, 0)
}

export const getLineTotal = (it) => {
	if (it?.final_amount !== undefined && it?.final_amount !== null) {
		return Number(it.final_amount) || 0
	}

	if (it?.extras?.finalAmmount !== undefined && it?.extras?.finalAmmount !== null) {
		return Number(it.extras.finalAmmount) || 0
	}

	const qty = Number(it?.quantity) || 0
	const price = Number(it?.price) || 0
	return qty * price
}

export const getLineTotalWithVat = (it) => {
	return getLineTotal(it) + getLineVat(it)
}

